export enum Gender {
  Male = 'male',
  Female = 'female',
}

export enum BMIStatus {
  Underweight = 'underweight',
  Normal = 'normal',
  Overweight = 'overweight',
  Obese = 'obese',
}

export interface HealthProfile {
  id: string;
  name: string;
  gender: Gender;
  birthDate: string;
  targetWeight?: number;
  height?: number;
  avatar?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HealthRecord {
  id: string;
  profileId: string;
  date: string;
  height: number;
  weight: number;
  bmi: number;
  status: BMIStatus;
  note?: string;
  timestamp: number;
  updatedAt?: string;
}

export interface ChildBMIThreshold {
  age: number;
  gender: Gender;
  malnutrition: number;
  overweight: number;
  obesity: number;
}

export interface GrowthStandard {
  age: number;
  p3: number;
  p50: number;
  p97: number;
}
